import React, { useEffect, useState } from "react";
import Select from "react-select";
import * as api from "../constant/API";
import Utils from "../constant/Utils";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import { Button } from "react-bootstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const CoachAttendanceReport = () => {

    const routes = all_routes;
    const roleId = localStorage.getItem('RoleId');

    const [coachCount, setCoachCount] = useState('');
    const [fromDate, setFromDate] = useState(() => {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1); // subtract 1 day
        return yesterday.toISOString().split('T')[0];
    });
    const [toDate, setToDate] = useState(() => {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1); // subtract 1 day
        return yesterday.toISOString().split('T')[0];
    });
    const [coachLogged, setCoachLogged] = useState([]);
    const [coachNotLogged, setCoachNotLogged] = useState([]);
    const [searchInput, setSearchInput] = useState('');

    useEffect(() => {
        attendanceReportCount();
        attendanceReport();
    }, [])

    function attendanceReportCount() {
        const reportCount = api.CoachAttendanceReportCount + "/" + formatDate(fromDate) + "/" + formatDate(toDate);
        //'?fromDate=' + formatDate(fromDate) + '&toDate=' + formatDate(toDate);
        fetch(reportCount, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((countResponse) => countResponse.json())
            .then((countResult) => {
                if (countResult.code == 401) {
                    Utils.logoutUser();
                }
                // console.log(countResult.data)
                setCoachCount(countResult.data)
            })
            .catch((error) => {
                console.log("Failed to fetch the coach attendance count", error)
            })
    }

    function attendanceReport() {
        const attendRpt = api.CoachReportAttendance + "/" + formatDate(fromDate) + "/" + formatDate(toDate);
        // "?fromDate=" + formatDate(fromDate) + "&toDate=" + formatDate(toDate);
        fetch(attendRpt, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((rptResponse) => rptResponse.json())
            .then((rptResult) => {
                if (rptResult.error == true) {
                    if (rptResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    // console.log(rptResult.data)
                    if (rptResult.data != "") {
                        setCoachLogged(rptResult.data.Present || [])
                        setCoachNotLogged(rptResult.data.Absent || [])
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch the coach attendance report", error)
            })
    }

    function attendanceReportExport() {
        const formData = new FormData();
        formData.append('fromDate', formatDate(fromDate));
        formData.append('toDate', formatDate(toDate));
        const exportRpt = api.CoachAttendanceReportExport;
        fetch(exportRpt, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData,
        })
            .then((exportReponse) => exportReponse.json())
            .then((exportResult) => {                
                if (exportResult.error == true) {
                    if (exportResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    const blob = new Blob([exportResult.data], { type: "application/vnd.ms-excel" });
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = "CoachAttendanceReport.xls"; // Save file as .xls
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                }
            })
            .catch((error) => {
                console.log("Failed to export Coach Attendance Report", error);
            })
    }

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const filteredData = coachLogged.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const filteredAbsentData = coachNotLogged.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const coachLoggedRender = (rowData) => {
        return <span>{rowData.Name}</span>
    }

    const coachLoggedInstRender = (rowData) => {
        return <span>{rowData.Institution}</span>
    }

    const coachLoggedDateRender = (rowData) => {
        return <span>{rowData.created_on}</span>
    }

    const slNoNotRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const coachNotLoggedRender = (rowData) => {
        return <span>{rowData.Name}</span>
    }

    const coachNotLoggedDateRender = () => {
        // return <span>{rowData.created_on}</span>
        return (
            <>
                {formatDate(fromDate) === formatDate(toDate) ? (
                    <span>{formatDate(fromDate)}</span>
                ) : (
                    <span>{formatDate(fromDate)} to {formatDate(toDate)}</span>
                )}
            </>
        )
    }

    return (
        <>
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <h3 className="text-center mb-40">
                                    <i className="fa fa-university"></i>
                                    Coach Attendance Report
                                </h3>
                            </div>
                            <div>
                                <Link
                                    to={routes.reports}
                                    className="btn btn-primary save-profile"
                                >
                                    <i className="fas fa-arrow-left"></i>Back
                                </Link>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="court-tab-content">
                                        <div className="court-tab-content">
                                            <div className="card card-tableset">
                                                <div className="card-body">
                                                    <div className="coache-head-blk">
                                                        <div className="row align-items-center">
                                                            <div className="row col-md-12">
                                                                <div className="row col-md-12 court-sortby sortbyset">
                                                                    <div className="col-md-3">
                                                                        <div className="mb-10">
                                                                            <label className="sortbytitle"><h6>From Date</h6></label>
                                                                            <input className="col-md-12" type="date" style={{ border: "1px solid hsl(0, 0%, 80%)", borderRadius: "4px", minHeight: "38px" }} value={fromDate} onChange={(e) => setFromDate(e.target.value)}></input>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <div className="mb-10">
                                                                            <label className="sortbytitle"><h6>To Date</h6></label>
                                                                            <input className="col-md-12" type="date" style={{ border: "1px solid hsl(0, 0%, 80%)", borderRadius: "4px", minHeight: "38px" }} value={toDate} onChange={(e) => setToDate(e.target.value)}></input>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <div className="save-changes text-sm mt-4">
                                                                            <Button onClick={attendanceReport}>Submit</Button>
                                                                            <Button onClick={attendanceReportExport}>Export to Excel</Button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-12"></div>
                                                                <div className="col-md-12 mt-4 pt-4">
                                                                    <div className="text-center">
                                                                        {formatDate(fromDate) === formatDate(toDate) ? (
                                                                            <h6>Details of Date: {formatDate(fromDate)}</h6>
                                                                        ) : (
                                                                            <h6>Details of: {formatDate(fromDate)} to {formatDate(toDate)}</h6>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className="row col-md-12">
                                                                    <table className="table datatable">
                                                                        <thead className="thead-light">
                                                                            <tr>
                                                                                <th className="text-center text-uppercase">Number of Coach</th>
                                                                                <th className="text-center text-uppercase">Number of Institute</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td className="text-center">{coachCount.coachCount}</td>
                                                                                <td className="text-center">{coachCount.institutionCount}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                                <div className="col-md-12 pt-4">
                                                                    <div className="text-center"><h6><i className="fas fa-user-check" />Coaches Logged In</h6></div>
                                                                </div>
                                                                <div className="col-md-12">
                                                                </div>
                                                                <div className="col-md-12">
                                                                </div>
                                                                <div className="col-md-6">
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="dataTables_filter">
                                                                        <label>
                                                                            <input
                                                                                type="text"
                                                                                value={searchInput}
                                                                                onChange={(e) => setSearchInput(e.target.value)}
                                                                                placeholder="Search"
                                                                                className="form-control"
                                                                            />
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <div className="row col-md-12">
                                                                    <div className="tab-content">
                                                                        <div
                                                                            className="tab-pane fade show active"
                                                                            id="nav-Recent"
                                                                            role="tabpanel"
                                                                            aria-labelledby="nav-Recent-tab"
                                                                            tabIndex={0}
                                                                        >
                                                                            <div className="table-responsive table-datatble">
                                                                                <DataTable
                                                                                    className="table datatable"
                                                                                    value={filteredData}
                                                                                    paginator
                                                                                    rows={10}
                                                                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                                                                    // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                                                    pageLinkSize={3}
                                                                                >
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="slNo"
                                                                                        body={slNoRender}
                                                                                        header="Sl No"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="Name"
                                                                                        body={coachLoggedRender}
                                                                                        header="Coach Name"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="Institution"
                                                                                        body={coachLoggedInstRender}
                                                                                        header="Institution"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="created_on"
                                                                                        body={coachLoggedDateRender}
                                                                                        header="Date"
                                                                                    ></Column>
                                                                                </DataTable>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-12">
                                                                    <div className="text-center"><h6><i className="fas fa-user-times" />Coaches Not Logged In</h6></div>
                                                                </div>
                                                                <div className="col-md-12">
                                                                </div>
                                                                <div className="col-md-12">
                                                                </div>
                                                                <div className="col-md-6">
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="dataTables_filter">
                                                                        <label>
                                                                            <input
                                                                                type="text"
                                                                                value={searchInput}
                                                                                onChange={(e) => setSearchInput(e.target.value)}
                                                                                placeholder="Search"
                                                                                className="form-control"
                                                                            />
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <div className="row col-md-12">
                                                                    <div className="tab-content">
                                                                        <div
                                                                            className="tab-pane fade show active"
                                                                            id="nav-Recent"
                                                                            role="tabpanel"
                                                                            aria-labelledby="nav-Recent-tab"
                                                                            tabIndex={0}
                                                                        >
                                                                            <div className="table-responsive table-datatble">
                                                                                <DataTable
                                                                                    className="table datatable"
                                                                                    value={filteredAbsentData}
                                                                                    paginator
                                                                                    rows={10}
                                                                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                                                                    // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                                                    pageLinkSize={3}
                                                                                >
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="slNo"
                                                                                        body={slNoNotRender}
                                                                                        header="Sl No"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="Name"
                                                                                        body={coachNotLoggedRender}
                                                                                        header="Coach Name"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="created_on"
                                                                                        body={coachNotLoggedDateRender}
                                                                                        header="Date"
                                                                                    ></Column>
                                                                                </DataTable>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div >
                    </div >
                </div >
            </div >
        </>
    );
};

export default CoachAttendanceReport;